import { render, staticRenderFns } from "./DeployDispatch.vue?vue&type=template&id=b74ec806&"
import script from "./DeployDispatch.vue?vue&type=script&lang=js&"
export * from "./DeployDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports